import { join, size } from 'lodash/fp';

import { Application, NewRelicEventType } from '@mews/enums';
import { getNewRelicPerformanceEvents, getUrlResource, NewRelicEvent } from '@mews/framework';
import { getCurrentRoute } from '../modules/app/selectors';
import { getConfigurationIds, getPlatformEnvironment, getVersion } from '../modules/configuration/selectors';
import { DistributorThunkAction } from '../types';

interface WithContext {
    context: Window;
}

const reportNewRelicEvents =
    (events: NewRelicEvent<NewRelicEventType>[], { context }: WithContext): DistributorThunkAction =>
    (_, getState, { newRelicReporterService }) => {
        if (!newRelicReporterService) {
            return;
        }

        const state = getState();

        const url = getUrlResource(context);
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
        const normalizedUrl = getCurrentRoute(state) || null;
        const environment = getPlatformEnvironment(state) ?? null;
        const configurationIds = getConfigurationIds(state);
        const numberOfConfigurations = size(configurationIds);
        const appVersion = getVersion();

        const enhancedEvents = events.map((event) => ({
            url,
            normalizedUrl,
            environment,
            numberOfConfigurations,
            configurationIds: join(';', configurationIds),
            appName: Application.BookingEngine,
            appVersion,
            ...event,
        }));

        newRelicReporterService.sendEvents(enhancedEvents);
    };

export const reportNewRelicPerformanceObserverEvents =
    (entryList: PerformanceObserverEntryList, { context }: WithContext): DistributorThunkAction =>
    (dispatch) => {
        const entries = entryList.getEntries();
        const newRelicEvents = getNewRelicPerformanceEvents(entries, { networkInformation: null });

        dispatch(reportNewRelicEvents(newRelicEvents, { context }));
    };
